import { PRODUCT_CARD_IMAGES_FOLDER_PATH } from 'src/app/shared/constants-and-enums/asset-paths';
import { environment } from 'src/environments/environment';

export function productCardImageUrl(category: string | undefined, displayCategories: Partial<Record<string, string>>): string {
    if (!category) {
        return '';
    }
    return environment.basePathCdn + PRODUCT_CARD_IMAGES_FOLDER_PATH + (displayCategories[category] ?? category) + '_400.jpg';
}
